import React, { Component } from 'react'
import { graphql } from 'gatsby'
import Fade from 'react-reveal/Fade';
import Helmet from 'react-helmet'
import Slider from 'react-slick'
import Link from '../utils/link'

class Product extends Component {

  state = {
    variant: this.props.data.shopifyProduct.variants[0],
    price: this.props.data.shopifyProduct.variants[0].price,
    imageActive: 0,
    showMore: false,
    moreOrLess: 'More',
    shoeSize: {},
    shoeSizeB: {},
    validationError: false
  }

  _changeImage(i) {
    this.setState({ imageActive: i })
  }

  _selectShoeSize = e => {
    let properties = { key: e.target.name, value: e.target.value }
    this.setState({ 
      shoeSize: properties,
      validationError: false
    })
  }

  _selectShoeSizeB = e => {
    let properties = { key: e.target.name, value: e.target.value }
    this.setState({ 
      shoeSizeB: properties,
      validationError: false
    })
  }

  _selectVariant = (variant) => () => {
    this.setState({ 
      variant, 
      price: variant.price
    })
  }

  _addToCart = () => {
    let { variant, shoeSize, shoeSizeB } = this.state
    let properties = []
    if (shoeSize && Object.keys(shoeSize).length > 0 && shoeSize.constructor === Object) {
      properties.push(shoeSize)
    }
    if (shoeSizeB && Object.keys(shoeSizeB).length > 0 && shoeSizeB.constructor === Object) {
      properties.unshift(shoeSizeB)
    }
    if ( document && document.querySelector('.single-product__info select')?.length > 0 && properties.length == 0 ) {
      this.setState({ validationError: true })
    } else if ( document && document.querySelector('.single-product__info select[name="Shoe Size B"]')?.length > 0 && properties.length == 1 ) {
      this.setState({ validationError: true })
    } else {
      this.props.addVariantToCart(variant.storefrontId, 1, properties)
    }
  }

  _toggleContent = () => {
    let label = 'More'
    if ( this.state.moreOrLess === 'More' ) {
      label = 'Less'
    }
    this.setState({
      showMore: !this.state.showMore,
      moreOrLess: label
    })
  }

  render() {
    const product = this.props.data.shopifyProduct

    let { variant, price, imageActive, moreOrLess, showMore, validationError } = this.state

    const settings = {
      infinite: true,
      speed: 600,
      fade:true,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      cssEase: 'ease',
      pauseOnHover: false,
      focusOnSelect: false,
    }

    return (
      <>
        <Helmet
          title={product.title}
          meta={[
            { name: 'description', content: product.description },
          ]}
        >
          <body className="single-product" />
        </Helmet>
        <article className="single-product__wrapper">
          <div className='single-product__inner'>
            <button className='single-product__back' onClick={() => window && window.history.back()}>
              <svg xmlns="http://www.w3.org/2000/svg" width="4.738" height="8.288" viewBox="0 0 4.738 8.288">
                <path d="M12.679,10.337,15.815,7.2a.592.592,0,0,0-.839-.836l-3.553,3.55a.591.591,0,0,0-.017.817l3.568,3.575a.592.592,0,1,0,.839-.836Z" transform="translate(-11.251 -6.194)" fill="#2c2c2c"/>
              </svg>
              Back
            </button>
            <h1 className='mobile'>{product.title}</h1>
            <section className='single-product__gallery'>
              { product.images.length > 0 &&
                <div className='single-product__image'>
                  <img src={product.images[imageActive].originalSrc} alt={product.title} />
                  <ul className='choose__gallery'>
                    { product.images.map((img, i) => (
                      <li className={`${imageActive === i ? 'active' : ''}`} onClick={() => this._changeImage(i)} key={i}><img src={img.originalSrc} alt={product.title} /></li>
                    ))}
                  </ul>
                </div>
              }
              <div className='single-product__content'>

                { product.handle === 'shelter-pack-1' &&
                  <p className='single-product__quote'>Some people want it to happen.<br />Some wish it would happen.<br />The PRO PACK is the start of making it happen.</p>
                }
                { product.handle === 'shelter-pack-2' &&
                  <p className='single-product__quote'>Today be thankful and think how rich you are.<br />Your family is priceless, your time is gold and your health is wealth.</p>
                }

                <div className={`single-product__content-inner ${showMore ? 'active' : ''}`} dangerouslySetInnerHTML={{ __html: product.descriptionHtml }} />
                <span className='single-product__read-more' onClick={() => this._toggleContent()}>Read {moreOrLess}</span>

              </div>
            </section>
            <section className='single-product__info'>
              <h1 className='desktop'>{product.title}</h1>
              { product.handle === 'shelter-bike-shoes' &&
                <p className='single-product__variant-label'>Shoe Size</p>
              }
              { product.handle === 'bike-shoes' &&
                <p className='single-product__variant-label'>Shoe Size</p>
              }
              { product.handle === 'shelter-pack-1' &&
                <div className={`${validationError ? 'validation-error' : ''}`}>
                  <p className='single-product__variant-label select-box'>Shoe Size</p>
                  <select name='Shoe Size' onChange={this._selectShoeSize}>
                    <option>Please select</option>
                    <option value='37'>37</option>
                    <option value='38'>38</option>
                    <option value='39'>39</option>
                    <option value='40'>40</option>
                    <option value='41'>41</option>
                    <option value='42'>42</option>
                    <option value='43'>43</option>
                    <option value='44'>44</option>
                    <option value='45'>45</option>
                    <option value='46'>46</option>
                  </select>
                  { validationError && <p className='error'>Please select size.</p> }
                </div>
              }
              { product.handle === 'shelter-pack-2' &&
                <div className={`${validationError ? 'validation-error' : ''}`}>
                  <p className='single-product__variant-label select-box'>Shoe Size A</p>
                  <select name='Shoe Size A' onChange={this._selectShoeSizeB}>
                    <option>Please select</option>
                    <option value='37'>37</option>
                    <option value='38'>38</option>
                    <option value='39'>39</option>
                    <option value='40'>40</option>
                    <option value='41'>41</option>
                    <option value='42'>42</option>
                    <option value='43'>43</option>
                    <option value='44'>44</option>
                    <option value='45'>45</option>
                    <option value='46'>46</option>
                  </select>
                  <p className='single-product__variant-label select-box'>Shoe Size B</p>
                  <select name='Shoe Size B' onChange={this._selectShoeSize}>
                    <option>Please select</option>
                    <option value='37'>37</option>
                    <option value='38'>38</option>
                    <option value='39'>39</option>
                    <option value='40'>40</option>
                    <option value='41'>41</option>
                    <option value='42'>42</option>
                    <option value='43'>43</option>
                    <option value='44'>44</option>
                    <option value='45'>45</option>
                    <option value='46'>46</option>
                  </select>
                  { validationError && <p className='error'>Please select size.</p> }
                </div>
              }
              { product.variants.length > 1 &&
                <div className='single-product__variations'>
                  { product.variants.map((el, i) => {
                    let props = {
                      key: i,
                      className: `btn--variation ${el.storefrontId === variant.storefrontId ? 'active' : ''}`,
                      onClick: this._selectVariant(el),
                    }
                    return (<button {...props}>{ el.title }</button>)
                  }) }
                </div>
              }
              <div className='single-product__description'>
                { product.handle !== 'shelter-pack-1' && product.handle !== 'shelter-bike' && product.handle !== 'shelter-pack-2' &&
                  <div>
                    <span className='single-product__price'>${parseFloat(price).toFixed(2)}</span>
                  </div>
                }
                { product.handle === 'shelter-pack-1' &&
                  <div>
                    <p>
                      <span className='large'>$2325 outright</span>
                    </p>
                    <p>$89 weekly installments available for 6 months. <Link to='https://ondemand.the-shelter.com.au/register/pack-1'>Click here</Link></p>
                  </div>
                }
                { product.handle === 'shelter-bike' &&
                  <div>
                    <p>
                      <span className='large'>$2350 outright</span>
                    </p>
                  </div>
                }
                { product.handle === 'shelter-pack-2' &&
                  <div>
                    <p>
                      <span className='large'>$2595 outright</span>
                    </p>
                    <p>$99 weekly installments available for 6 months. <Link to='https://ondemand.the-shelter.com.au/register/pack-2'>Click here</Link></p>
                  </div>
                }
              </div>
              <div className='add-to-cart__wrapper'>
                <button className='btn--cart btn' onClick={this._addToCart}>Add to cart</button>
                { product.handle === 'shelter-pack-1' &&
                  <p className='single-product__quote'>Some people want it to happen.<br />Some wish it would happen.<br />The PRO PACK is the start of making it happen.</p>
                }
                { product.handle === 'shelter-pack-2' &&
                  <p className='single-product__quote'>Today be thankful and think how rich you are.<br />Your family is priceless, your time is gold and your health is wealth.</p>
                }
              </div>
            </section>
          </div>
        </article>
      </>
    )
  }

}

export default Product

export const productQuery = graphql`
  query ShopifyProductById($id: String!) {
    shopifyProduct(id: { eq: $id }) {
      id
      storefrontId
      title
      description
      descriptionHtml
      handle
      images {
        originalSrc
      }
      priceRangeV2 {
        minVariantPrice {
          amount
          currencyCode
        }
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      variants {
        title
        storefrontId
        price
      }
    }
  }
`
